import React from 'react';

import { UserContextProvider } from '../../../../../ReactComponents/Contexts/UserContext';
import { ProductAvailabilityNotification } from './ProductAvailabilityNotification';
import { ProductAvailabilityNotificationProps } from './ProductAvailabilityNotificationProps.csharp';

export const ProductPageAvailabilityNotificationWrapper = (props: ProductAvailabilityNotificationProps) => (
    <UserContextProvider>
        <ProductAvailabilityNotification {...props} />
    </UserContextProvider>
);
